import * as axiosService from "./../axiosService";


export const getFAQ=(languageISOCode)=>{
    return axiosService.Get(process.env.REACT_APP_COMMON_API_URL + `/HelpAndSupport/GetFAQs?languageISOCode=${languageISOCode}`);
}
export const GetComplaints = (payload) => {
    return axiosService.Post(process.env.REACT_APP_COMMON_API_URL + `/HelpAndSupport/GetComplaints`, payload);
};

export const RaiseComplaints = (payload) => {
    return axiosService.Post(process.env.REACT_APP_COMMON_API_URL + `/HelpAndSupport/RaiseComplaints`, payload);
};
export const RaiseOrderList = (payload) => {
    return axiosService.Post(process.env.REACT_APP_COMMON_API_URL + `/Order/GetOrdersListForRaiseIssue`, payload);
};

export const SendHelpSupportMail = (payload) => {
    return axiosService.Post(process.env.REACT_APP_COMMON_API_URL + `/HelpAndSupport/SendHelpSupportMail`, payload);
};
export const MarkDisputeAsReopened = (payload) => {
    return axiosService.Post(process.env.REACT_APP_COMMON_API_URL + `/HelpAndSupport/MarkDisputeAsReopened`, payload);
};
